// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qi_a bhg_su bhg_kv bhg_kw","PostDetailRight__brandDaysPosts":"qi_b bhg_su bhg_kv bhg_kw"};